var ApplicantAPI = require("../../../common/api/applicant");
module.exports = function ($scope) {
  var vm = this;
  $scope.submit = function () {
    $scope.closeThisDialog({action:"close"});
  };
};
